import { Component, ElementRef, Input, QueryList, ViewChildren } from '@angular/core';
import { BaseFormList, MessageService, notCloseMessageOptions } from '../../../../core';
import { EnumRelevancia } from '../../../../domains/core/settings/portfolio/enums/relevancia.enum';
import { EnumSituacaoConcorrente } from '../../../../domains/environment/concorrentes/enums/situacao-concorrente.enum';
import { ISelectOption } from '../../../../domains/shared/components/select/models/select-option.interface';
import { ClienteConcorrente } from './cliente-concorrente';
import { ClienteConcorrenteSequenciaService } from './services';

@Component({
    selector: 'sgt-cliente-concorrente',
    templateUrl: './cliente-concorrente.component.html',
    styleUrls: ['./cliente-concorrente.component.less']
})
export class ClienteConcorrenteComponent implements BaseFormList<ClienteConcorrente> {
    @Input() canEdit = true;
    @Input() entities: ClienteConcorrente[] = [];
    // @Input() mediaCompra: number;

    // percParticipacaoTotal = 0;
    // valorMediaCompraTotal = 0;

    readonly opcoesRelevancia: ISelectOption[] = [
        { id: EnumRelevancia.A, label: 'A — Alta' },
        { id: EnumRelevancia.B, label: 'B — Média' },
        { id: EnumRelevancia.C, label: 'C — Baixa' }
    ];

    @ViewChildren('concorrenteSelect', { read: ElementRef }) concorrentesSelects: QueryList<ElementRef<HTMLElement>>;
    @ViewChildren('relevanciaSelect', { read: ElementRef }) relevanciasSelects: QueryList<ElementRef<HTMLElement>>;

    constructor(private messageService: MessageService,
                private clienteConcorrenteSequenciaService: ClienteConcorrenteSequenciaService) { }
                // private clienteConcorrenteCalculoService: ClienteConcorrenteCalculoService) { }

    // ngOnChanges(changes: SimpleChanges) {
    //     for (const propName in changes) {
    //         if (propName === 'entities') {
    //             this.calcularParticipacaoTotal();
    //             this.calcularValorMediaCompraTotal();
    //         } else if (propName === 'mediaCompra') {
    //             if (!changes[propName].isFirstChange()) {
    //                 this.recalcularTodasMediasCompra();
    //             }
    //         }
    //     };
    // }

    moverSequenciaParaCima(index: number) {
        if (!this.canEdit) {
            return;
        }
        this.clienteConcorrenteSequenciaService.moverParaCima(index, this.entities);
    }

    moverSequenciaParaBaixo(index: number) {
        if (!this.canEdit) {
            return;
        }
        this.clienteConcorrenteSequenciaService.moverParaBaixo(index, this.entities);
    }

    /** Calcula o total do percentual de todos os concorrentes */
    // private calcularParticipacaoTotal() {
    //     this.percParticipacaoTotal = this.clienteConcorrenteCalculoService.calcularPercParticipacaoTotal(this.entities);
    // }

    /** Ao alterar o percentual de participação */
    // onChangePercParticipacao(entity: ClienteConcorrente) {
    //     this.calcularParticipacaoTotal();
    //     this.calcularValorMediaCompra(entity);
    //     this.calcularValorMediaCompraTotal();
    // }

    // private calcularValorMediaCompra(entity: ClienteConcorrente) {
    //     entity.mediaCompra = this.clienteConcorrenteCalculoService.calcularValorMediaCompra(this.mediaCompra, entity.percParticipacao);
    // }

    /** Recalcula o valor da média de compra de todos os concorrentes */
    // private recalcularTodasMediasCompra() {
    //     if (!this.entities) {
    //         return;
    //     }

    //     this.entities.forEach(entity => {
    //         this.calcularValorMediaCompra(entity);
    //     });

    //     this.calcularValorMediaCompraTotal();
    // }

    /** Calcula o valor da média de compra total de todos os concorrentes */
    // private calcularValorMediaCompraTotal() {
    //     this.valorMediaCompraTotal = this.clienteConcorrenteCalculoService.calcularValorMediaCompraTotal(this.entities);
    // }

    /** Rola até o select do concorrente através do index informado */
    private setFocusConcorrenteSelect(index: number) {
        if (index < 0) {
            return;
        }
        this.concorrentesSelects?.toArray()[index]?.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    /** Rola até o select da relevância do concorrente através do index informado */
    private setFocusRelevanciaSelect(index: number) {
        if (index < 0) {
            return;
        }
        this.relevanciasSelects?.toArray()[index]?.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    /** Mantém o concorrente vinculado coerente com o id selecionado; limpa a referência quando o usuário troca a seleção */
    onConcorrenteChange(entity: ClienteConcorrente, idConcorrente: number | null) {
        entity.idConcorrente = idConcorrente;
        if (!entity.concorrente || entity.concorrente.id !== idConcorrente) {
            entity.concorrente = undefined;
        }
    }

    /** IDs dos concorrentes já selecionados em outras linhas, para não oferecê-los novamente */
    idsSelecionadosExceto(index: number): number[] {
        return (this.entities || [])
            .filter((_, i) => i !== index)
            .map(entity => entity.idConcorrente)
            .filter((id): id is number => !!id);
    }

    labelRelevancia(relevancia: EnumRelevancia | null): string {
        return this.opcoesRelevancia.find(opcao => opcao.id === relevancia)?.label ?? '-';
    }

    isConcorrenteInativo(entity: ClienteConcorrente): boolean {
        return entity.concorrente?.situacao === EnumSituacaoConcorrente.INATIVO;
    }

    insert() {
        if (!this.canEdit) {
            return;
        }
        if (!this.entities) {
            this.entities = [];
        }
        const entity = new ClienteConcorrente();
        entity.sequencia = this.clienteConcorrenteSequenciaService.getProximaSequencia(this.entities);
        this.entities.push(entity);
    }

    delete(index: number) {
        if (!this.canEdit) {
            return;
        }

        this.messageService.confirm('Deseja realmente excluir esse concorrente?').then(result => {
            if (result) {
                this.entities.splice(index, 1);
                this.clienteConcorrenteSequenciaService.atualizar(this.entities);
                // this.calcularParticipacaoTotal();
                // this.calcularValorMediaCompraTotal();
            }
        });
    }

    /** Verifica se o form dos concorrentes presentes no cliente está válido */
    isValid(): boolean {
        if (!this.canEdit) {
            return true;
        }

        // Sem nenhum concorrente
        if (!this.entities || this.entities.length === 0) {
            return true;
        }

        // Percorrendo os concorrentes
        for (let i = 0; i < this.entities.length; i++) {
            const entity = this.entities[i];
            const nome = entity.concorrente?.nome;
            const sufixoNome = nome ? ` ${nome}` : '';

            // Sem concorrente
            if (!entity.idConcorrente) {
                this.messageService.warning('Selecione ou exclua o concorrente', 'Concorrente não selecionado', notCloseMessageOptions);
                setTimeout(() => this.setFocusConcorrenteSelect(i), 300);
                return false;
            }

            // Sem relevância
            if (!entity.relevancia) {
                this.messageService.warning(`Selecione uma relevância para o concorrente${sufixoNome}`, 'Relevância do concorrente não selecionada', notCloseMessageOptions);
                setTimeout(() => this.setFocusRelevanciaSelect(i), 300);
                return false;
            }

            // Concorrente já adicionado
            const count = this.entities.filter(entityFilter => entityFilter.idConcorrente == entity.idConcorrente).length;
            if (count > 1) {
                this.messageService.warning('Selecione outro concorrente ou exclua o concorrente duplicado', nome ? `Concorrente ${nome} já adicionado` : 'Concorrente já adicionado', notCloseMessageOptions);
                setTimeout(() => this.setFocusConcorrenteSelect(i), 300);
                return false;
            }
        }

        return true;
    }

    /** Resolve os concorrentes presentes no cliente */
    resolve() {
        if (!this.entities) {
            return;
        }

        // Removendo os itens do array que não possuirem o id do concorrente informado
        for (let i = this.entities.length; i--; ) {
            const concorrente = this.entities[i];
            if (!concorrente.idConcorrente) {
                this.entities.splice(i, 1);
            }
        }
    }
}
